<template>
  <div>
    <div class="summernote-wrapper">
      <div class="summernote-div"></div>
    </div>
  </div>
</template>

<script>


import {config} from "@/services";

import $ from 'jquery';
import 'summernote';
import 'summernote/dist/summernote.css';
import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.css'; //css editado por error tarjeta 193

export default {
  props: ['html'],
  data: function () {
    return {
      summernote: {
        code:this.html,
      },
      pushed: 0,
      changed: 0,
      $summernoterElement : null,
    }
  },
  watch: {
    summernote: {
      handler(val){
        if (this.changed > 0) {
          this.changed--;
        } else {
          this.pushed++;
          this.setText(val.code);
        }
      },
      deep: true
    }
  },
  mounted() {
    let component = this;
    let config = {};
    component.$summernoterElement = $(this.$el).find('.summernote-div').first();
    config.callbacks = {
      onImageUpload: function(files) {
        component.sendFile(files[0], component);
      }
    },
    config.disableDragAndDrop = true,
    config.minHeight = 300;
    config.maxHeight = null;
    config.toolbar =  [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontname', ['fontname']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']],
          ['table', ['table']],
          ['insert', ['link', 'picture']],
      ]; 
    // init the editor
    component.$summernoterElement.summernote(config);
    // set code
    component.$summernoterElement.summernote('code', component.summernote.code);
    // set callback to pass event back to parent 
    component.$summernoterElement.on('summernote.change', 
      function(we, contents) {
        if (component.pushed > 0) {
            component.pushed--;
        } else {
            component.changed++;
            component.summernote.code = contents;
            component.$emit('update', component.summernote.code);
        }
      }
    );
  },
  methods: {
    sendFile: function(file, Editor) {
      var formData = new FormData();
      formData.append("file_data", file);
      formData.append("carpeta", "documento");
      formData.append("id_cliente", this.$store.state.usuario.id_cliente);

      fetch(`${config.uploadUrl}`,{
        method:'POST',
        body:formData
      }).then(respuesta => respuesta.json().then(data => ({status:respuesta.status, body: data}))).then(obj => {
        if(obj.status == 200){
          Editor.$summernoterElement.summernote('insertImage', obj.body.url, 'filename');
        }
      });
    },
    setText: function (text) {
      this.$summernoterElement.summernote('code', text);
    },
    getFromSummernote: function (){
      return this.$summernoterElement.summernote('code');
    }
  },
}
</script>

<style scoped>
.summernote-wrapper >>> i {
  color:black;
}

.summernote-wrapper >>> .note-toolbar {
  background-color: #f5f5f5;
  border-color: #ddd;
}

.summernote-wrapper >>> .btn-default {
  background-color:white
}

.summernote-wrapper >>> .note-icon-caret {
  display: none;
}

.summernote-wrapper >>> .note-image-btn {
  color: black;
}

.summernote-wrapper >>> .modal-title {
  display: none;
}


.summernote-wrapper >>> .tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

</style>



